import { ReactComponent as CurrentLocationSvg } from '../../../../assets/icons/CurrentLocation.svg';

import { createIconComponent } from './createIconComponent';

export const CurrentLocationIcon = createIconComponent(CurrentLocationSvg);
